// Publish only real, customer-approved clips (ideally 20–30 seconds).
// No fabricated names, quotes, endorsements, posters or stock testimonial videos.
// Each entry:
// { id, name, company, country, title, videoUrl, posterUrl,
//   companyLogoUrl?, captionsUrl?, captionLanguage?: 'en', durationSeconds?: 25 }
// videoUrl accepts a public HTTPS MP4/WebM URL or a build-time /media/file.mp4 asset.
// Uploads should live in durable media storage/CDN, not runtime server disk.
// This static site has no upload form or media-storage backend.
export const testimonials = [];

export const testimonialsConfig = {
  heading: 'What Our Customers Say',
  supportingText: 'Hear directly from the businesses we work with.',
  showEmptyState: true,
};